import type { OverviewResponse } from "contracts/api/dashboard/responses";
import { ISSUE_SEVERITY } from "contracts/enums/core";
import { CORE_WEB_VITALS_CONFIDENCE_LEVEL } from "contracts/enums/web-vitals";
import { Show } from "solid-js";
import {
  pageDisplayLabel,
  rawPagePath,
} from "../pages/boundaries/page-label.parser";
import type { JourneyStep } from "./journeyTypes";

export function JourneyPageCard(props: {
  step: JourneyStep;
  site: OverviewResponse["site"];
  selected: boolean;
  alternative?: boolean;
  onSelect: () => void;
}) {
  const title = () => pageDisplayLabel(props.step.page, props.site);
  const score = () => props.step.page.contentFitness?.score ?? null;
  const priorityIssues = () =>
    props.step.issues.filter(
      (issue) =>
        issue.severity === ISSUE_SEVERITY.CRITICAL ||
        issue.severity === CORE_WEB_VITALS_CONFIDENCE_LEVEL.HIGH,
    ).length;

  return (
    <button
      class={`journey-page-card${props.selected ? " is-selected" : ""}${
        props.alternative ? " is-alternative" : ""
      }`}
      type="button"
      aria-pressed={props.selected}
      aria-label={`${title()}, ${props.step.roleLabel}, Content Fitness ${
        score() === null ? "not scored" : score()
      }, ${props.step.issues.length} linked issues`}
      title={`${title()}\n${rawPagePath(props.step.page)}`}
      onClick={props.onSelect}
    >
      <span class="journey-card-role">{props.step.roleLabel}</span>
      <strong>{title()}</strong>
      <small>{rawPagePath(props.step.page)}</small>
      <span class="journey-card-meta">
        <span
          class={`journey-card-score${score() === null ? " is-empty" : ""}`}
        >
          {score() === null ? "Not scored" : `CF ${score()}`}
        </span>
        <Show when={props.step.issues.length > 0}>
          <span class={priorityIssues() > 0 ? "has-priority" : ""}>
            {priorityIssues() > 0 ? "! " : ""}
            {props.step.issues.length} issue
            {props.step.issues.length === 1 ? "" : "s"}
          </span>
        </Show>
      </span>
    </button>
  );
}
